import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";
import { EmailValidationPattern } from "../_helpers/validateEmail";

@Component({
  moduleId: module.id,
  templateUrl: "register.component.html",
  styleUrls: ["register.component.scss"],
})
export class RegisterComponent implements OnInit {
  public readonly emailValidationPattern = EmailValidationPattern;
  model: any = {};
  loading = false;
  messages: any;
  sitecptch: any;
  isPasswordVisible = false;

  constructor(
    private router: Router,
    private dataService: DataService,
    private alertService: AlertService
  ) { }

  toggleVisibility(event: MouseEvent) {
    event.preventDefault();
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  register() {
    this.loading = true;
    this.dataService.registerUser(this.model).subscribe(
      (data) => {
        this.alertService.success("Registration successful", true);
        this.router.navigate(["/login"]);
      },
      (error) => {
        const body = error.json && error.json();
        this.alertService.error(
          body && body.statusText
            ? this.messages[body.statusText]
              ? this.messages[body.statusText]
              : decodeURIComponent(body.statusText)
            : (error && error.statusText) || error
        );
        this.loading = false;
      }
    );
  }

  ngOnInit() {
    this.messages = localStorage.getItem("messages")
      ? JSON.parse(localStorage.getItem("messages"))
      : undefined;
    this.dataService.messages.subscribe((nextVal) => {
      if (nextVal) {
        this.messages = nextVal;
      }
    });
    this.sitecptch = JSON.parse(localStorage.getItem("sitecptch"));
  }
}



// WEBPACK FOOTER //
// ./src/app/register/register.component.ts